import React, { useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import LevelsDropDown       from "./DropDowns/LevelsDropDown";
import LanguagesDropDown    from "./DropDowns/LanguagesDropDown";
import AvailabilityDropDown from "./DropDowns/AvailabilityDropDown";

export default function Preferences({ initial = {}, saveProfile }) {
  const [expectSession, setExpectSession]   = useState(initial?.expectSession || "");
  const [mentorLevel, setMentorLevel]       = useState(initial?.mentorLevel || []);
  const [languages, setLanguages]           = useState(initial?.languagesSpoken || []);
  const [availability, setAvailability]     = useState(initial?.availability || []);
  const [saving, setSaving] = useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    await saveProfile({
      preferences: {
        expectSession,
        mentorLevel,
        languagesSpoken: languages,
        availability,
      },
    });
    setSaving(false);
  };

  return (
    <>
      <Backdrop open={saving} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={onSave}>
        <div><h3>Preferences</h3></div>

        <div className={Classes.infoConMiddle}>
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Preferred Mentor Level</h5>
              <LevelsDropDown selected={mentorLevel} onChange={setMentorLevel} />
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Languages Spoken</h5>
              <LanguagesDropDown selected={languages} onChange={setLanguages} />
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Availability</h5>
              <AvailabilityDropDown selected={availability} onChange={setAvailability} />
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Expected Sessions Per Month</h5>
              <input
                type="number"
                min="1"
                name="expectSession"
                className={Classes.inputField}
                placeholder="e.g. 2"
                value={expectSession}
                onChange={(e) => setExpectSession(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className={Classes.flexEnd}>
          <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
        </div>
      </form>
    </>
  );
}
